module.exports = __webpack_public_path__ + "static/img/xg_pic.e0cd297.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/xg_pic.jpg
// module id = SHuY
// module chunks = 1